import React from "react";

const SkillsSlider = ({ skills }) => (
  <div className="skills-slider">
    <div className="skills-slider__track">
      {[...skills, ...skills].map((skill, idx) => (
        <div className="skills-slider__item" key={idx}>
          {skill.icon && (
            <i
              className={skill.icon}
              style={{ fontSize: 40, marginRight: 12 }}
              title={skill.name}
            />
          )}
          <span>{skill.name || skill}</span>
        </div>
      ))}
    </div>
  </div>
);

export default SkillsSlider;